import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {routing} from './app.routing';
import {LoginComponent} from './login/index';
import {HomeComponent} from './home/index';
import {LoginModule} from './login/login.module';
import {AuthGuard} from './_guards/index';
import {AuthenticationService, InvitationService, UserService, WorkflowService, LinkAccountService, TwoFAService, SocialLoginService} from './_services/index';
import {CommonModule} from '@angular/common';
import {SharedModule} from './shared';
import {HttpClientModule} from '@angular/common/http';
import {UserContext} from './_context/user.context';
import {AppAuthenticationComponent} from './twoFA/app-authentication/app-authentication.component';
import {SmsAuthenticationComponent} from './twoFA/sms-authentication/sms-authentication.component';
import {ChooseAuthMethodComponent} from './twoFA/choose-auth-method/choose-auth-method.component';
import {TwoFASetupComponent} from './twoFA/twoFA-setup/twoFA-setup.component';
import {StompService} from 'ng2-stomp-service';
import {VerifyCodeComponent} from './twoFA/verify-code/verify-code.component';
import {TwoFALoginAuthenticationComponent} from './twoFA/twoFA-login-authentication/twoFA-login-authentication.component';
import {AppSetupSuccessComponent} from './twoFA/app-setup-success/app-setup-success.component';
import {TwoFaConfirmationComponent} from './twoFA/two-fa-confirmation/two-fa-confirmation.component';
import {LinkAccountInfoComponent} from './link-accounts/link-account-info.component';
import {CookieService} from 'ngx-cookie-service';
import {CookieModule} from 'ngx-cookie';
import {InvitationSignUpComponent} from './invitation-sign-up/invitation-sign-up.component';
import {FacebookCallbackComponent} from './invitation-sign-up/facebook-callback/facebook-callback.component';
import {GoogleCallbackComponent} from './invitation-sign-up/google-callback/google-callback.component';
import {LinkedinCallbackComponent} from './invitation-sign-up/linkedin-callback/linkedin-callback.component';
import {TwitterCallbackComponent} from './invitation-sign-up/twitter-callback/twitter-callback.component';
import {FacebookLoginCallbackComponent} from './invitation-sign-up/facebook-callback/facebook-login-callback/facebook-login-callback.component';
import {GoogleLoginCallbackComponent} from './invitation-sign-up/google-callback/google-login-callback/google-login-callback.component';
import {LinkedInLoginCallbackComponent} from './invitation-sign-up/linkedin-callback/linked-in-login-callback/linked-in-login-callback.component';
import {TwitterLoginCallbackComponent} from './invitation-sign-up/twitter-callback/twitter-login-callback/twitter-login-callback.component';
import {AuthenticationFacebookCallbackComponent} from './authentication-email/authentication-facebook-callback/authentication-facebook-callback.component';
import {AuthenticationGoogleCallbackComponent} from './authentication-email/authentication-google-callback/authentication-google-callback.component';
import {AuthenticationLinkedinCallbackComponent} from './authentication-email/authentication-linkedin-callback/authentication-linkedin-callback.component';
import {SpecificPlaceLoginComponent} from './specific-place-login/specific-place-login.component';
import { UserPromptSubmitComponent } from './user-prompt/user-prompt-submit.component';
import { SamlLoginComponent } from './saml-login';
import { JwtModule } from '@auth0/angular-jwt';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {environment} from '@env/environment';
import {AuthXWorkflowModule} from '@authx/authx-workflow-lib';
import {Oauth2LoginComponent} from './oauth2-login/oauth2-login.component';
import { BrokerLoginComponent } from './login/broker-login/broker-login.component';

export function tokenGetter() {
  return JSON.parse(localStorage.getItem('currentUser')).token;
}

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    routing,
    HttpClientModule,
    LoginModule,
    SharedModule,
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      },
    }),
    CommonModule,
    CookieModule.forRoot(),
    BrowserAnimationsModule,
    AuthXWorkflowModule.with(environment.gateway_api_url)
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    BrokerLoginComponent,
    SamlLoginComponent,
    Oauth2LoginComponent,
    VerifyCodeComponent,
    AppAuthenticationComponent,
    SmsAuthenticationComponent,
    TwoFASetupComponent,
    ChooseAuthMethodComponent,
    TwoFALoginAuthenticationComponent,
    AppSetupSuccessComponent,
    TwoFaConfirmationComponent,
    LinkAccountInfoComponent,
    InvitationSignUpComponent,
    FacebookCallbackComponent,
    GoogleCallbackComponent,
    LinkedinCallbackComponent,
    TwitterCallbackComponent,
    FacebookLoginCallbackComponent,
    GoogleLoginCallbackComponent,
    LinkedInLoginCallbackComponent,
    TwitterLoginCallbackComponent,
    AuthenticationFacebookCallbackComponent,
    AuthenticationGoogleCallbackComponent,
    AuthenticationLinkedinCallbackComponent,
    SpecificPlaceLoginComponent,
    UserPromptSubmitComponent,
  ],
  providers: [
    UserContext,
    HttpClientModule,
    AuthGuard,
    AuthenticationService,
    UserService,
    TwoFAService,
    LinkAccountService,
    LoginModule,
    StompService,
    CookieService,
    InvitationService,
    SocialLoginService,
    WorkflowService,
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
